import { writable, derived } from "svelte/store";

export const turnstileSolved = writable(true); // Siempre "resuelto"
export const turnstileCreated = writable(false);
export const turnstileEnabled = derived([], () => false); // Siempre apagado